import api from './api';

// 내 휴무 신청 목록 조회
export const getMySchedules = async () => {
  const response = await api.get('/schedule/my');
  return response.data;
};

// 전체 휴무 신청 목록 조회 (관리자)
export const getAllSchedules = async () => {
  const response = await api.get('/schedule/all');
  return response.data;
};

// 휴무 신청 생성
export const createScheduleRequest = async (date: Date, reason: string) => {
  const response = await api.post('/schedule', {
    date: date.toISOString(),
    reason,
  });
  return response.data;
};

// 휴무 신청 승인/거절 (관리자)
export const updateScheduleStatus = async (id: string, status: 'APPROVED' | 'REJECTED') => {
  const response = await api.patch(`/schedule/${id}/status`, {
    status,
  });
  return response.data;
};

// 휴무 신청 삭제
export const deleteScheduleRequest = async (id: string) => {
  const response = await api.delete(`/schedule/${id}`);
  return response.data;
};
